import { LoadableAfterPaint } from '@confluence/loadable';

export const SmartButtonLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SmartButton" */ '../SmartButton.tsx')).SmartButton,
});
